export const SHARED_PAGE_URL_PREFIX = '/shared';
